<div class="container-custom">
  <div class="row align-items-center justify-content-center"> 
<form #form='ngForm' autocomplete="off" (submit)="onSubmit(form)">
      <div class="card dropshadow-custom" style="width: 21rem;">
        <div class="card-header">Prosegur Keys</div>
        <div class="card-body"><div><img src="assets/img/ico-prosegur.svg" alt="" width="27" height="27" class="float-right"/>          
          <h4 class="card-title mb-4 mt-1">{{'USER.LOGIN'| translate}}</h4></div>
          <hr>
          <div class="form-group">
            <input class="form-control w-100" placeholder="{{'USER.USER'| translate}}" #UserName="ngModel" name="Login" [(ngModel)]="formModel.Login" required>
          </div>
          <!-- form-group// -->
          <div class="form-group">
            <input class="form-control w-100" placeholder="{{'USER.PASSWORD'| translate}}" #Password="ngModel" name="Password" [(ngModel)]="formModel.Password" required type="password" >
          </div>
          <!-- form-group// -->
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <button type="submit" class="btn btn-custom" style="min-width: 100px" [disabled]="form.invalid">{{'USER.LOGIN'| translate}} </button>
              </div>
              <!-- form-group// --> 
            </div>
          </div>
          <!-- .row// --> 
        </div>
        <!-- card-body// --> 
      </div>
      <!-- card// -->
	</form>
  </div>
</div>
